import { supabase } from '../../supabaseClient';
import { v4 as uuidv4 } from 'uuid';

// Default values for empty fields
const defaultData = {
  title: 'Default Title',
  subtitle: 'No Subtitle Provided',
  tags: 'default',
  route: '/default-route',
  country: 'Unknown Country',
  state: 'Unknown State',
  district: 'Unknown District',
  city: 'Unknown City',
  pincode: '000000',
  latitude: 0.0,
  longitude: 0.0,
};

export async function insertEntity(formData) {
  const {
    entityType,
    entityId,
    name,
    title,
    subtitle,
    description,
    tags,
    route,
    country,
    state,
    district,
    city,
    pincode,
    latitude,
    longitude
  } = formData;

  // Generate a unique UUID for the new entity
  const id = uuidv4();

  // Use default values if any field is empty
  const entityTitle = title || defaultData.title;
  const entitySubtitle = subtitle || defaultData.subtitle;
  const entityTags = tags || defaultData.tags;
  const entityRoute = route || defaultData.route;
  const entityCountry = country || defaultData.country;
  const entityState = state || defaultData.state;
  const entityDistrict = district || defaultData.district;
  const entityCity = city || defaultData.city;
  const entityPincode = pincode || defaultData.pincode;
  const entityLatitude = latitude || defaultData.latitude;
  const entityLongitude = longitude || defaultData.longitude;
  const entityDescription = description || '';  // Allow empty description if not provided

  try {
    // Insert data into Supabase
    const { data, error } = await supabase.from('entities').insert([{
      id,
      entity_type: entityType || '',  // Allow empty entityType
      entity_id: entityId || '',  // Allow empty entityId
      name: name || '',  // Allow empty name
      title: entityTitle,
      subtitle: entitySubtitle,
      description: entityDescription,
      tags: entityTags.split(','),
      route: entityRoute,
      country: entityCountry,
      state: entityState,
      district: entityDistrict,
      city: entityCity,
      pincode: entityPincode,
      latitude: parseFloat(entityLatitude),
      longitude: parseFloat(entityLongitude),
      location: `SRID=4326;POINT(${entityLongitude} ${entityLatitude})`,
      full_text_search: `${name} ${entityDescription}`,
    }]);

    if (error) {
      console.error('Error inserting data:', error.message);
      throw new Error(`Error inserting data: ${error.message}`);
    }

    console.log('Data inserted successfully:', data);
    return data;  // Return data on success
  } catch (error) {
    console.error('Unexpected error:', error);
    throw new Error(`Unexpected error: ${error.message}`);
  }
}

// Update entity data by entity_id
export async function updateEntity(entityId, formData) {
  const {
    entityType,
    name,
    title,
    subtitle,
    description,
    tags,
    route,
    country,
    state,
    district,
    city,
    pincode,
    latitude,
    longitude
  } = formData;

  // Use default values if any field is empty
  const entityTitle = title || defaultData.title;
  const entitySubtitle = subtitle || defaultData.subtitle;
  const entityTags = tags || defaultData.tags;
  const entityRoute = route || defaultData.route;
  const entityCountry = country || defaultData.country;
  const entityState = state || defaultData.state;
  const entityDistrict = district || defaultData.district;
  const entityCity = city || defaultData.city;
  const entityPincode = pincode || defaultData.pincode;
  const entityLatitude = latitude || defaultData.latitude;
  const entityLongitude = longitude || defaultData.longitude;
  const entityDescription = description || '';  // Allow empty description if not provided

  try {
    // Perform the update on the Supabase table based on the entity_id
    const { data, error } = await supabase
      .from('entities')
      .update({
        entity_type: entityType || '',  // Allow empty entityType
        name: name || '',  // Allow empty name
        title: entityTitle,
        subtitle: entitySubtitle,
        description: entityDescription,
        tags: entityTags.split(','),
        route: entityRoute,
        country: entityCountry,
        state: entityState,
        district: entityDistrict,
        city: entityCity,
        pincode: entityPincode,
        latitude: parseFloat(entityLatitude),
        longitude: parseFloat(entityLongitude),
        location: `SRID=4326;POINT(${entityLongitude} ${entityLatitude})`,
        full_text_search: `${name} ${entityDescription}`,
      })
      .eq('entity_id', entityId);  // Match by entity_id

    if (error) {
      console.error('Error updating data:', error.message);
      throw new Error(`Error updating data: ${error.message}`);
    }

    console.log('Data updated successfully:', data);
    return data;  // Return data on success
  } catch (error) {
    console.error('Unexpected error:', error);
    throw new Error(`Unexpected error: ${error.message}`);
  }
}
